import React from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import Icon from '../icon';
import Render from '../render';
// eslint-disable-next-line yola/@typescript-eslint/no-unused-vars
import { iconsList } from '../icon/glyphs';

class FloatingAction extends React.Component {
  hoverTimeout;

  static defaultProps = {
    className: null,
    stick: 'none',
    offsetX: 0,
    offsetY: 0,
    inverseOffsetOrigin: false,
    direction: 'down',
    tooltip: null,
    iconSize: '24',
    iconStrokeWidth: '2',
    buttonColorType: 'accent',
    buttonSizeType: 'normal',
  };

  constructor(props) {
    super(props);

    this.state = {
      hovered: false,
    };

    this.bindMethods();
  }

  componentWillUnmount() {
    clearTimeout(this.hoverTimeout);
  }

  onMouseEnter() {
    clearTimeout(this.hoverTimeout);

    this.showTooltip();
  }

  onMouseLeave() {
    const hideHoverDelay = 275;

    const { hovered } = this.state;

    if (hovered) {
      this.hoverTimeout = setTimeout(this.hideTooltip, hideHoverDelay);
    }
  }

  bindMethods() {
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
  }

  hideTooltip() {
    this.setState({
      hovered: false,
    });
  }

  showTooltip() {
    this.setState({
      hovered: true,
    });
  }

  render() {
    const {
      icon,
      offsetX,
      offsetY,
      inverseOffsetOrigin,
      direction,
      tooltip,
      onClick,
      className,
      stick,
      iconSize,
      iconStrokeWidth,
      buttonColorType,
      buttonSizeType,
    } = this.props;
    const { hovered } = this.state;
    const floatingActionClass = classNames(
      className,
      'ws-floating-action',
      `ws-floating-action--${direction}`,
      `ws-floating-action--stick-${stick}`,
      {
        'ws-floating-action--hovered': hovered,
      }
    );

    const floatingActionStyles = {};
    if (inverseOffsetOrigin) {
      floatingActionStyles.right = `${offsetX}px`;
      floatingActionStyles.bottom = `${offsetY}px`;
    } else {
      floatingActionStyles.left = `${offsetX}px`;
      floatingActionStyles.top = `${offsetY}px`;
    }

    const isMobile = bowser.mobile || bowser.tablet;
    const shouldRenderTooltip = !isMobile && Boolean(tooltip);

    const floatingActionButtonClass = classNames('ws-floating-action__button', {
      'ws-floating-action__button--mobile': isMobile,
    });

    return (
      <div
        className={`${floatingActionClass} button-size--${buttonSizeType}`}
        style={floatingActionStyles}
        // @ts-ignore TS(2322): Type '(() => void) | null' is not assignable to ty... Remove this comment to see the full error message
        onMouseEnter={shouldRenderTooltip ? this.onMouseEnter : null}
        // @ts-ignore TS(2322): Type '(() => void) | null' is not assignable to ty... Remove this comment to see the full error message
        onMouseLeave={shouldRenderTooltip ? this.onMouseLeave : null}
      >
        <button
          className={`${floatingActionButtonClass} ws-floating-button-color--${buttonColorType}`}
          type="button"
          onClick={onClick}
        >
          <Icon glyph={icon} size={iconSize} strokeWidth={iconStrokeWidth} />
        </button>
        <Render if={shouldRenderTooltip}>
          <div className={`ws-floating-action__tooltip ws-floating-action__tooltip--${direction}`}>
            {tooltip}
          </div>
        </Render>
      </div>
    );
  }
}

export default FloatingAction;
